// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search_shop_inner[data-v-65639365] {\n  width: 100%;\n  padding: 0 0.625rem;\n  height: 2.5rem;\n  line-height: 2.5rem;\n  border: 0.0625rem solid #dcdfe6;\n  border-radius: 1.25rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
